import { takeEvery, put, call } from 'redux-saga/effects';
import { AuthActions } from '../../actions/constant';
import authService from '../../../services/apiServices/authService';
import { SagaReturnType } from 'redux-saga/effects';

const {
  POST_RESET_PASSWORD_REQUEST,
  POST_RESET_PASSWORD_SUCCESS,
  POST_RESET_PASSWORD_FAILURE,
  POST_RESET_PASSWORD_LOADING,
} = AuthActions;

function* setPasswordPostResetPassword(action: any): SagaReturnType<any> {
  try {
    yield put({ type: POST_RESET_PASSWORD_LOADING });
    const response = yield call(authService.getPostTherapistResetPassword, action.payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: POST_RESET_PASSWORD_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: POST_RESET_PASSWORD_FAILURE, payload: error });
  }
}

function* PostResetPasswordSaga() {
  yield takeEvery(POST_RESET_PASSWORD_REQUEST, setPasswordPostResetPassword);
}

export default PostResetPasswordSaga;
